interface MenuToggleProps {
  isOpen: boolean;
  onClick: () => void;
  className?: string;
}

/**
 * Hamburger button whose three bars animate into an X: the middle bar slides
 * right and fades out, while the top and bottom bars fold to the center and
 * cross. Bars use `bg-current`, so the caller flips the text color for light
 * (header) vs dark (open overlay) contexts.
 */
const MenuToggle = ({ isOpen, onClick, className = "" }: MenuToggleProps) => (
  <button
    type="button"
    aria-label={isOpen ? "Close menu" : "Open menu"}
    aria-expanded={isOpen}
    onClick={onClick}
    className={`relative flex flex-col items-center justify-center w-10 h-10 -mr-2 rounded focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-current ${className}`}
  >
    <span
      aria-hidden="true"
      className={`block h-0.5 w-6 rounded-full bg-current transition-transform duration-300 ease-in-out ${
        isOpen ? "translate-y-[7px] rotate-45" : ""
      }`}
    />
    <span
      aria-hidden="true"
      className={`block h-0.5 w-6 my-[5px] rounded-full bg-current transition-all duration-150 ease-in-out ${
        isOpen ? "translate-x-6 opacity-0" : ""
      }`}
    />
    <span
      aria-hidden="true"
      className={`block h-0.5 w-6 rounded-full bg-current transition-transform duration-300 ease-in-out ${
        isOpen ? "-translate-y-[7px] -rotate-45" : ""
      }`}
    />
  </button>
);

export default MenuToggle;
